{
  "VALIDATION_FAILED": "يرجى التحقق من البيانات المدخلة",
  "USERNAME_TAKEN": "اسم المستخدم هذا مستخدم بالفعل",
  "NO_PLATFORM_ACCESS": "ليس لديك صلاحية الوصول إلى هذا النظام",
  "UA_UNAVAILABLE": "تعذر الوصول إلى الدخول الموحد. أعد المحاولة بعد قليل.",
  "UNAUTHENTICATED": "يجب تسجيل الدخول",
  "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "TOKEN_EXPIRED": "انتهت صلاحية الجلسة",
  "TOKEN_REVOKED": "تم إلغاء الجلسة",
  "FORBIDDEN": "ليس لديك صلاحية لتنفيذ هذا الإجراء",
  "NOT_FOUND": "العنصر المطلوب غير موجود",
  "routeNotFound": "هذه الصفحة غير موجودة.",
  "CONFLICT": "تعارض في البيانات. أعد تحميل البيانات الحالية.",
  "UNIQUE_VIOLATION": "هذه القيمة مستخدمة بالفعل",
  "FOREIGN_KEY_VIOLATION": "هذا العنصر مرتبط بعناصر أخرى ولا يمكن حذفه",
  "RATE_LIMITED": "عدد كبير جدا من المحاولات. أعد المحاولة بعد قليل.",
  "IDEMPOTENCY_KEY_REUSED": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "REQUEST_IN_PROGRESS": "لا يزال هذا الطلب قيد المعالجة",
  "PAYLOAD_TOO_LARGE": "البيانات المرسلة تتجاوز الحجم المسموح به",
  "UNPROCESSABLE": "تعذرت معالجة الطلب. تحقق من البيانات المرسلة.",
  "INTERNAL_ERROR": "تعذر إكمال العملية. أعد المحاولة أو تواصل مع المسؤول.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة حاليا. أعد المحاولة بعد قليل.",
  "IN_USE": "لا يمكن الحذف لأنه مستخدم. يمكنك تعطيله بدلا من ذلك.",
  "BRANCH_NOT_ALLOWED": "غير متاح في هذا الفرع",
  "CODE_TAKEN": "هذا الرمز مستخدم بالفعل",
  "INVALID_STATE": "لا يمكن تنفيذ هذا الإجراء في الحالة الحالية",
  "NOTHING_TO_CHANGE": "لا توجد تغييرات للحفظ",
  "CUSTOMERS_UNAVAILABLE": "تعذر الربط بمنصة العملاء، أعد المحاولة",
  "PHONE_TAKEN": "رقم الهاتف مسجل لعميل آخر في العملاء",
  "CUSTOMER_DELETED": "العميل محذوف في العملاء، لا يمكن تغيير رقم هاتفه",
  "CUSTOMERS_FORBIDDEN": "رفضت منصة العملاء تغيير رقم الهاتف لهذا النظام",
  "DEBT_LIMIT_EXCEEDED": "المبلغ مع الدين الحالي يتجاوز سقف الدين البالغ {{limit}} دينار",
  "MOVEMENT_DATE_IN_FUTURE": "لا يمكن أن يكون تاريخ المعاملة في المستقبل",
  "MOVEMENT_BEFORE_LOCKED": "لا يمكن أن يسبق تاريخ المعاملة آخر حركة مُرحَّلة ({{date}})",
  "ACCOUNT_BALANCE_NOT_ZERO": "لا يمكن حذف حساب رصيده لا يساوي صفر",
  "network": "تعذر الاتصال بالخادم. تحقق من اتصالك وأعد المحاولة.",
  "timeout": "لم نتمكن من تأكيد اكتمال العملية. تحقق من الحالة الحالية قبل إعادة المحاولة.",
  "referenceId": "رقم المرجع: {{requestId}}",
  "PHONE_EXISTS": "رقم الهاتف مسجل للعميل {{name}}",
  "ACCOUNT_NAME_EXISTS": "يوجد حساب بهذا الاسم لهذا العميل في هذا الفرع",
  "PHONE_REQUIRED": "رقم الهاتف مطلوب",
  "PHONE_INVALID": "رقم الهاتف غير صالح",
  "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
  "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة",
  "PHONE_VERIFICATION_REQUIRED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "PHONE_VERIFICATION_INVALID": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "OTP_INVALID": "الرمز غير صحيح",
  "OTP_EXPIRED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_ATTEMPTS_EXCEEDED": "تم تجاوز عدد المحاولات، اطلب رمزا جديدا",
  "OTP_RESEND_TOO_SOON": "إعادة إرسال الرمز غير متاحة الآن",
  "OTP_SEND_LIMIT": "تم إرسال عدد كبير من الرموز لهذا الرقم",
  "OTP_SEND_FAILED": "تعذر إرسال رمز التحقق عبر واتساب ولم يتم الحفظ. حاول مجددا، أو يمكن للمسؤول إيقاف تأكيد الرقم من الإعدادات",
  "OTP_ALREADY_VERIFIED": "تم تأكيد رقم الهاتف",
  "OTP_ALREADY_CONSUMED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_BINDING_MISMATCH": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_NOT_VERIFIED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "OTP_CONSUME_WINDOW_PASSED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "IDEMPOTENCY_CONFLICT": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "REVERIFY_NOT_NEEDED": "إعادة التحقق غير مطلوبة لهذا العميل",
  "CUSTOMER_PROFILE_INCOMPLETE": "بيانات العميل غير مكتملة، استكمل بياناته قبل أي حركة مدين أو دائن",
  "DEBTOR_MERGE_NOT_ALLOWED": "لا يمكن نقل حسابات هذا العميل",
  "DEBTOR_MERGE_STALE": "تغيرت بيانات العميلين، أغلق النافذة وحاول مرة أخرى",
  "DEBTOR_MERGE_HIDDEN_NAME_CONFLICT": "اسم حساب في فرع آخر مستخدم لدى العميل {{name}}. اطلب من موظف ذلك الفرع تعديله.",
  "CUSTOMERS_CALL_IN_FLIGHT": "جاري إرسال بيانات العميل إلى نظام العملاء، أعد المحاولة بعد لحظات"
}
